import React, { Fragment } from 'react';
import Head from 'components/Head';
import TeamCarousel from './TeamCarousel';

const OurLifestyle = () => {
  return (
    <Fragment>
      <Head
        title="Our Lifestyle - Siteplus Website builder"
        descrition="View our the exciting career opportunities now open at Siteplus!"
      />
      <article className="section__article section__article_tab_4">
        <section className="section section_career_1">
          <div className="wrapper">
            <div className="section__header-wrap _mb-74 _mb-note-32">
              <h2 className="title title_size_m _mb-18">Siteplus Team</h2>
              <p className="text text_size_l_old section__main-text">
                Jump into an exciting and fast-paced environment.
              </p>
            </div>
            <div className="row">
              <div className="col col-4 col-tablet-12">
                <div className="_mb-tablet-40">
                  <h3 className="title section__title title_size_s _mb-17">
                    Work with only the best
                  </h3>
                  <p className="text">
                    Our standards are extremely high. Joining our team means
                    you’ll be working with some of the industry’s most talented
                    minds. Our diverse, multinational team stems from all over
                    the globe.
                  </p>
                </div>
              </div>
              <div className="col col-4 col-tablet-12">
                <div className="_mb-tablet-40">
                  <h3 className="title section__title title_size_s _mb-17">
                    Inspired every day
                  </h3>
                  <p className="text">
                    We're always trying to push the boundaries of technology
                    while keeping everything simple. We challenge our team with
                    delivering exciting design concepts, engineering the best
                    tools, and creating delightful user experience. We do this
                    whilst maintaining a stable and lightning‑fast product
                    across multiple networks.
                  </p>
                </div>
              </div>
              <div className="col col-4 col-tablet-12">
                <h3 className="title section__title title_size_s _mb-17">
                  Growing with a Team
                </h3>
                <p className="text">
                  We act fast, move efficiently and we grow our skills in the
                  spirit of our team. We insist on the highest standards, take
                  on greater responsibilities, and achieve more together.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="section section_career_2">
          <div className="section__image-wrap">
            <TeamCarousel />
          </div>
        </section>

        {/* <section className="section section_career_3">
          <div className="wrapper">
            <div className="section__header-wrap _mb-82 _mb-note-32">
              <h2 className="title section__main-title _mb-5 _mb-note-8">Benefits & Perks</h2>
              <p className="text text_size_l_old section__main-text">
                We invest in our people and their happiness
              </p>
            </div>
            <div className="row">
              <div className="col col-3 col-tablet-12 _mb-tablet-42">
                <div className="section__icon-wrap _mb-27 _mb-note-11">
                  <Icon icon="icon-93" />
                </div>
                <h4 className="title title_size_s_old section__title _mb-22 _mb-note-8">Perks</h4>
                <p className="text section__text">
                  We believe in looking after our employees, which is why we provide free Friday
                  lunches, weekly snacks and other incentives to keep you motivated.
                </p>
              </div>
              <div className="col col-3 col-tablet-12 _mb-tablet-42">
                <div className="section__icon-wrap _mb-27 _mb-note-11">
                  <Icon icon="icon-80" />
                </div>
                <h4 className="title title_size_s_old section__title _mb-22 _mb-note-8">Bonuses</h4>
                <p className="text section__text">
                  At Siteplus, we reward our employees for their dedication and hard work with set
                  KPI's fixed into 25% of your annual gross salary.
                </p>
              </div>
              <div className="col col-3 col-tablet-12 _mb-tablet-42">
                <div className="section__icon-wrap _mb-27 _mb-note-11">
                  <Icon icon="icon-81" />
                </div>
                <h4 className="title title_size_s_old section__title _mb-22 _mb-note-8">Parties</h4>
                <p className="text section__text">
                  Work hard and party harder! That's our philosophy, which is why we hold social
                  get&#8209;togethers every 12 weeks and regular team&#8209;building events.
                </p>
              </div>
              <div className="col col-3 col-tablet-12">
                <div className="section__icon-wrap _mb-27 _mb-note-11">
                  <Icon icon="icon-82" />
                </div>
                <h4 className="title title_size_s_old section__title _mb-22 _mb-note-8">
                  Transparency
                </h4>
                <p className="text section__text">
                  We have an open culture based on respect for team members. You'll always know the
                  direction and status of the company.
                </p>
              </div>
            </div>
          </div>
        </section> */}

        {/* <section className="section section_career_4">
                <div className="wrapper">
                    <div className="section__header-wrap">
                        <h2 className="title section__title _mb-72 _mb-note-32">
                            Open Positions
                        </h2>
                    </div>
                    <div className="accordion _mb-tablet-40">
                        {map(VACANCIES, (vacancy, key) => (
                            <VacancyItem
                                name={vacancy.name}
                                location={vacancy.location}
                                key={key}
                            >
                                {vacancy.content}
                            </VacancyItem>
                        ))}
                    </div>
                </div>
            </section> */}
      </article>
    </Fragment>
  );
};

export default OurLifestyle;
